module.exports = __webpack_public_path__ + "static/media/cc.314968eb.svg";